import { Button } from "@/components/ui/button";
import { Search, MapPin, Package } from "lucide-react";
import searchMockup from "../../assets/generated_images/store_search_app_mockup.png";

export default function Visibility() {
  return (
    <section
      id="visibility"
      className="py-16 sm:py-20 md:py-24 bg-slate-50 dark:bg-slate-900/50 overflow-hidden"
    >
      <div className="container px-4 mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 max-w-7xl mx-auto">
          {/* Texto - Se mueve a la derecha en móvil */}
          <div className="flex-1 text-center lg:text-left order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs sm:text-sm font-bold mb-4 sm:mb-6">
              <Search className="w-3 h-3 sm:w-4 sm:h-4" />
              <span>Visibilidad Total</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4 sm:mb-6 tracking-tight leading-tight font-display">
              Encuentra lo que buscas, <br />
              <span className="text-primary text-gradient">
                donde sea que estés
              </span>
            </h2>
            <p className="text-slate-600 dark:text-slate-400 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0 px-4 sm:px-0">
              QvaPOS no solo gestiona tu negocio, conecta tus productos con
              clientes reales. Nuestra plataforma permite a los usuarios buscar
              productos en puntos de venta cercanos, ahorrando tiempo y dinero
              sin caminar de más.
            </p>

            <div className="space-y-4 sm:space-y-5 md:space-y-6 mb-8 sm:mb-10 max-w-md mx-auto lg:mx-0">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl bg-white dark:bg-slate-800 shadow-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-primary w-5 h-5 sm:w-6 sm:h-6" />
                </div>
                <div className="text-left">
                  <h4 className="font-bold text-slate-900 dark:text-white text-sm sm:text-base">
                    Ubicación Inteligente
                  </h4>
                  <p className="text-slate-500 text-xs sm:text-sm">
                    Tus productos aparecen en el mapa de tus clientes
                    potenciales.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl bg-white dark:bg-slate-800 shadow-xl flex items-center justify-center flex-shrink-0">
                  <Package className="text-secondary w-5 h-5 sm:w-6 sm:h-6" />
                </div>
                <div className="text-left">
                  <h4 className="font-bold text-slate-900 dark:text-white text-sm sm:text-base">
                    Control de Stock Real
                  </h4>
                  <p className="text-slate-500 text-xs sm:text-sm">
                    Los clientes ven disponibilidad exacta y precios
                    actualizados al momento.
                  </p>
                </div>
              </div>
            </div>

            <Button
              onClick={() =>
                (window.location.href = "http://127.0.0.1:5000/register")
              }
              className="h-11 sm:h-12 md:h-14 px-6 sm:px-8 md:px-10 rounded-full font-bold text-sm sm:text-base md:text-lg shadow-xl shadow-primary/20 hover:scale-105 transition-transform"
            >
              Digitalizar mi Inventario
            </Button>
          </div>

          {/* Imagen - Se mueve arriba en móvil */}
          <div className="flex-1 relative group perspective-1000 order-1 lg:order-2 w-full max-w-md lg:max-w-none mx-auto">
            <div className="absolute -inset-2 sm:-inset-3 md:-inset-4 bg-gradient-to-tr from-primary/20 to-secondary/20 blur-2xl sm:blur-3xl rounded-2xl sm:rounded-3xl md:rounded-[3rem] opacity-30 sm:opacity-50 group-hover:opacity-100 transition-opacity" />
            <div className="relative rounded-xl sm:rounded-2xl md:rounded-[2.5rem] overflow-hidden border-4 sm:border-6 md:border-8 border-white dark:border-slate-800 shadow-xl sm:shadow-2xl transition-all duration-700 [transform:rotateY(0deg)] md:[transform:rotateY(-15deg)_rotateX(5deg)] group-hover:md:[transform:rotateY(0deg)_rotateX(0deg)]">
              <img
                src={searchMockup}
                alt="QvaPOS Búsqueda de Productos"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
